import React, { useEffect, useState } from 'react';
import jadwalService from '../../services/jadwal-service';

export default function Jadwal(){
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      const res = await jadwalService.getAll();
      const items = Array.isArray(res) ? res : (res.data ?? res);
      setSchedules(items);
    } catch (err) {
      console.error(err);
    }
  };

  const groupedByDoctor = schedules.reduce((acc, sch) => {
    const name = sch.dokter?.nama || 'Dokter';
    if (!acc[name]) acc[name] = [];
    acc[name].push(sch);
    return acc;
  }, {});

  return (
    <main style={{padding:16}}>
      <h1>Jadwal Dokter</h1>
      {Object.keys(groupedByDoctor).length === 0 && <p>Tidak ada jadwal.</p>}
      {Object.keys(groupedByDoctor).map(doc => (
        <section key={doc} style={{ marginBottom: 18 }}>
          <h3>{doc}</h3>
          {groupedByDoctor[doc].map(sch => (
            <div key={sch.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <div>
                <div><b>{sch.hari}</b></div>
                <div>{sch.jam_mulai} - {sch.jam_selesai}</div>
                {sch.jam_check_in_hari_ini || sch.jam_check_out_hari_ini ? (
                  <div style={{ marginTop: 6 }}>
                    {sch.jam_check_in_hari_ini && <small>Check-in: {sch.jam_check_in_hari_ini}</small>}
                    {sch.jam_check_out_hari_ini && <small style={{ marginLeft: 8 }}>Check-out: {sch.jam_check_out_hari_ini}</small>}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </section>
      ))}
    </main>
  );
}
